import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurableGridComponent, GridConfig } from '../configurable-grid/configurable-grid.component';
import { MasterDataService } from '../../../Services/master-data.service';
import { BaseInspectionOverview } from 'src/app/DTOs/InspectionMasterData/productDetailModel';

@Component({
  selector: 'app-packaging',
  standalone: true,
  imports: [CommonModule, ConfigurableGridComponent],
  templateUrl: './packaging.component.html',
  styleUrl: './packaging.component.css'
})
export class PackagingComponent {
  gridConfig: GridConfig;

  constructor(private masterData: MasterDataService) {
    this.gridConfig = {
      getData: () => this.masterData.getPackagingOverview(),
      createItem: (item: BaseInspectionOverview) => this.masterData.createPackaging(item),
      updateItem: (id: number, item: BaseInspectionOverview) => this.masterData.updatePackaging(item.databaseId, item),
      deleteItem: (id: number) => this.masterData.deletePacking(id)
    };
  }
}
